import React, { createContext, useContext, useMemo, FC, PropsWithChildren } from 'react';

import { DEFAULT_GLOBAL_KEYBOARD_HANDLER_TOGGLERS } from '../constants/keyboard';

const GlobalKeyboardHandlerTogglersContext = createContext({
    ...DEFAULT_GLOBAL_KEYBOARD_HANDLER_TOGGLERS,
});

export const useGlobalKeyboardHandlerTogglers = () =>
    useContext(GlobalKeyboardHandlerTogglersContext);

export const GlobalKeyboardHandlerTogglersProvider: FC<PropsWithChildren> = ({ children }) => {
    const providerValue = useMemo(() => ({ ...DEFAULT_GLOBAL_KEYBOARD_HANDLER_TOGGLERS }), []);
    return (
        <GlobalKeyboardHandlerTogglersContext.Provider value={providerValue}>
            {children}
        </GlobalKeyboardHandlerTogglersContext.Provider>
    );
};
